import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/WAYBILLS`;

export const REDUCER_NAME = 'WAYBILLS';
export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shipments?domain=${SYSTEM_DOMAIN}?queryLMOnly=true`;

export const ROUTES = {
  ROOT: '/waybills',
};
